/**
 * TKP-215: 409 (ör. envanterde kullanılan sözlük kaydı silinemez) yanıtındaki sunucu gerekçesi; yoksa undefined.
 * rest istemcisi hatayı `{ status, data }` biçiminde reddeder; axios ham biçimi (`response`) de tanınır.
 */
export const conflictMessage = (error) => {
  const status = Number((error && error.status) || (error && error.response && error.response.status));
  const data = (error && error.data) || (error && error.response && error.response.data) || {};
  return status === 409 && data.message ? data.message : undefined;
};
